import React from "react";
import { List, Typography, Empty, Collapse, Alert } from "antd";
import _ from "lodash";
import moment from "moment";

const { Panel } = Collapse;

const renderValueIfDate = (value) => {
  if (moment(value, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
    return moment.utc(value, 'YYYY-MM-DDTHH:mm:ssZ').format('DD/MM/YYYY HH:mm:ss')
  } else {
    return value
  }
};

export default function ActivityDetails({ record }) {
  const size = _.size(record.children);
  // Agrupar as mudanças por ID e field usando Lodash
  const groupedChanges = _.groupBy(
    record.changes,
    (change) => `${change.id}_${change.field}`
  );

  // Transformar os valores dos campos "multipla" e "referenciado" em um único valor com vírgula
  for (const key in groupedChanges) {
    const values = groupedChanges[key].map((item) => item.value);
    const uniqueValues = _.uniq(values);
    groupedChanges[key] = {
      ...groupedChanges[key][0], // Manter apenas um item para o campo no grupo
      value: uniqueValues.map(item => renderValueIfDate(item)).join(", "), // Juntar os valores com vírgula
    };
  }

  const uniqueIds = _.uniqBy(record.changes, "id");

  const renderChangesList = (changes, action) => {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 16px', marginBottom: 12 }}>
        {changes.map((item, index) => {
          const fieldName = (item.field) ? (item.field === "createdAt" ? "Criado em" : item.field.charAt(0).toUpperCase() + item.field.slice(1)) : null;
          const oldValue = !_.isNumber(item.oldValue) ? (_.size(item.oldValue) > 0 ? item.oldValue : "N/A") : _.toString(item.oldValue);
          const newValue = !_.isNumber(item.oldValue) ? (_.size(item.value) > 0 ? item.value : "N/A") : _.toString(item.value);
          const showOldAndNewValues = action === "UPDATE";
          return (
            <div key={index} style={{ marginBottom: 3 }}>
              {fieldName && <Typography.Text strong>• {fieldName}:</Typography.Text>}{" "}
              {showOldAndNewValues ? (
                <>
                  <Typography.Text code>{renderValueIfDate(oldValue)}</Typography.Text> para{" "}
                  <Typography.Text code>{renderValueIfDate(newValue)}</Typography.Text>
                </>
              ) : (
                <Typography.Text code>{renderValueIfDate(item.value) || "N/A"}</Typography.Text>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const RenderByFieldValue = () => {
    if (!record.children || _.size(record.children) === 0) {
      return (
        <div
          style={{
            maxHeight: "350px",
            overflowY: "auto",
            padding: "0 15px 0 15px",
          }}
        >
          {uniqueIds.map((item) => (
            <div key={item.id} style={{ marginBottom: 16 }}>
              {item.id && <Typography.Text strong style={{ display: 'block', marginBottom: 4 }}>ID: {item.id}</Typography.Text>}
              {renderChangesList(
                Object.keys(groupedChanges)
                  .filter((key) => groupedChanges[key].id === item.id)
                  .map((key) => groupedChanges[key]),
                "CREATE"
              )}
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <Typography.Text style={{ display: 'block', padding: '10px 15px' }}>
          {size === 1
            ? `${size} atividade relacionada`
            : `${size} atividades relacionadas`}
        </Typography.Text>
      );
    }
  };

  const actions = {
    CREATE: <RenderByFieldValue />,
    UPDATE: (
      <div style={{
        maxHeight: "350px",
        overflowY: "auto",
        padding: "0 15px 0 15px",
      }}>
        {uniqueIds.map((item) => (
          <div key={item.id} style={{ marginBottom: 16 }}>
            {(item.id) && <Typography.Text strong style={{ display: 'block', marginBottom: 4 }}>ID: {item.id}</Typography.Text>}
            {renderChangesList(
              Object.keys(groupedChanges)
                .filter((key) => groupedChanges[key].id === item.id)
                .map((key) => groupedChanges[key]),
              "UPDATE"
            )}
          </div>
        ))}
      </div>
    ),
    DELETE: (
      <div style={{
        maxHeight: "350px",
        overflowY: "auto",
        padding: "0 15px 0 15px",
      }}>
        {uniqueIds.map((item) => (
          <div key={item.id} style={{ marginBottom: 8 }}>
            {item.id && <Typography.Text strong style={{ display: 'block' }}>ID: {item.id}</Typography.Text>}
          </div>
        ))}
      </div>
    ),
  };

  const hasChanges = actions[record.action] && _.size(record.changes) > 0;
  const hasRawData = (record.action === "CREATE" || record.action === "UPDATE" || record.action === "DELETE") && (record.rawData && _.size(record.rawData) > 0);

  if (!hasChanges && !hasRawData) {
    return (
      <Empty
        description="Nenhuma ação foi realizada nesta atividade."
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <>
      {record.metadata?.truncated && (
        <Alert 
          message={`Exibindo apenas uma amostra visual dos primeiros ${record.changes?.length || 100} de um total de ${record.metadata.totalCount || size} registros.`} 
          description="Os detalhes visuais foram limitados por questões de otimização, mas todas as modificações foram realizadas na base de dados."
          type="info" 
          showIcon 
          style={{ marginBottom: 12 }} 
        />
      )}
      <Collapse ghost defaultActiveKey={hasChanges ? ['1'] : ['2']}>
        {hasChanges && (
          <Panel header="Alterações" key="1">
            {actions[record.action]}
          </Panel>
        )}
        {hasRawData && (
          <Panel header="Log de Dados" key="2">
            <div style={{
              maxHeight: "400px",
              overflowY: "auto",
              background: "var(--cp-surface-2)",
              padding: "10px",
              borderRadius: "4px"
            }}>
              <pre style={{ margin: 0, fontSize: "12px" }}>
                {JSON.stringify(record.rawData, null, 2)}
              </pre>
            </div>
          </Panel>
        )}
      </Collapse>
    </>
  );
}

